// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"983":"e3b68552","1464":"981d6ce1","2040":"dbd8753b"}[chunkId] + ".chunk.css";
};